import * as HELPER from "../../../src/config/helper";
import { useLanguage } from "../../../src/context/LanguageContext";
import { useState,useEffect } from "react";
import {REMITTANCE_TYPE} from '../../config/constant'

const AgencyPayoutCard = (props: any) => {
  const {revenue,remittanceDetails} = props
  const { translations } = useLanguage();

  const [bipd , setBipd] = useState(null);

  useEffect(() => {
      if (Array.isArray(props.remittanceDetails) && props.remittanceDetails.length > 0) {
        const agencyRemittance = props.remittanceDetails.find((b: any) => b.remittance_type_name === REMITTANCE_TYPE['agency']);
        if(agencyRemittance){
          // setBipd(agencyRemittance.bipd)
          setBipd(agencyRemittance.bipd !== undefined && agencyRemittance.bipd !== null && agencyRemittance.bipd !== "" ? agencyRemittance.bipd : null);
        }
      }
      // eslint-disable-next-line
      },[remittanceDetails])

  return (
    <>
      {/* Agency Payout Card */}
      <div className="remittance-card">
        <div className="remittance-header">
          <h2>{translations.Remittance?.["AGENCY_PAYOUT"] || translations.commonMsg?.loading}</h2>
        </div>
        <div className="remittance-table">
          <div className="remittance-row">
            <span>{translations.Remittance?.["REFERRAL_FEE_SCHEME"] || translations.commonMsg?.loading}</span>
            <span className="highlight">{revenue?.referral_fee_scheme || 'NA'}</span>
          </div>
          <div className="remittance-row">
            <span>{translations.Remittance?.["REFERRAL_PAYOUT_WHT_EXCLUSIVE"] || translations.commonMsg?.loading}</span>
            <span>{`${HELPER.addCurrencyFormatting(Number(revenue?.referral_fee_payout_wht_exclusive || 0).toFixed(2))}`}</span>
          </div>
          <div className="remittance-row">
            <span>
             {
                (bipd !== undefined && bipd !== null)
                  ? (translations.Remittance?.["COMMISSION_NET_RATE_BI_PD"] || translations.commonMsg?.loading)
                  : (translations.Remittance?.["COMMISSION_NET_RATE_NO_BI_PD"] || translations.commonMsg?.loading)
              }
            </span>
            <span>{revenue?.commission_rate_oto_bi_pd || 0} {bipd !== undefined && bipd !== null ? `, ${bipd}%` : ""}</span>
          </div>
          <div className="remittance-row">
            <span>{translations.Remittance?.["REFERRAL_PAYOUT_WHT_INCLUSIVE"] || translations.commonMsg?.loading}</span>
            <span>{`${HELPER.addCurrencyFormatting(Number(revenue?.referral_fee_payout_wht_inclusive || 0).toFixed(2))}`}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgencyPayoutCard;
